import { useEffect, useRef } from 'react';
import * as navigation from 'app-level/navigation';

import { usePoolOptions } from './usePoolOptions';
import { usePortfolioFilters } from '../Portfolio/usePortfolioFilters';

import { Pool } from 'query/getPools';
interface PoolOption {
  label: string;
  value: string;
  poolData: Pool;
}

interface UsePoolSelectionProps {
  setSelectedPool: (pool: PoolOption | null) => void;
}

export const usePoolSelection = ({ setSelectedPool }: UsePoolSelectionProps) => {
  const assetClass = navigation.usePortfolioAssetClass();
  const { poolFromUrl, setPool } = usePortfolioFilters();
  const { poolOptions } = usePoolOptions({ assetClass });
  // Initialize pool from URL
  useEffect(() => {
    if (!poolOptions || !poolFromUrl) return;
    const selected = poolOptions.find((pool) => pool.value === poolFromUrl);
    if (selected) {
      setSelectedPool(selected);
    } else {
      setPool(null);
    }
  }, [poolOptions, poolFromUrl, setPool, setSelectedPool]);

  // Reset pool selection when asset class changes via navigation
  const prevAssetClass = useRef(assetClass);
  useEffect(() => {
    if (prevAssetClass.current && prevAssetClass.current !== assetClass) {
      // Asset class changed, reset pool selection
      setSelectedPool(null);
      setPool(null);
    }
    prevAssetClass.current = assetClass;
  }, [assetClass, setPool, setSelectedPool]);
};
